import { useRef, useState } from 'react';
import {
  canUseNewTimelineForUnmigratedLiveEvent,
  getClipDisplayLabel
} from '@goldcast/player-config/src/utils/clipUtils';
import { AudioControlsPopup } from './AudioControlsPopup';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import TooltipV2 from '@/components/TooltipV2';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';
import Icon from '@/components/atoms/Icon';
import Button from '@/components/atoms/Button/Button';
import { classnames } from '@/libs/utils';
import useAnalytics from '@/hooks/useAnalytics';

export const AudioControlsButton = () => {
  const [isAudioPopupOpen, setIsAudioPopupOpen] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);
  const { clipData } = useClipsContext();
  const { trackAudioControlButtonClick } = useAnalytics();

  const clickHandler = () => {
    if (canUseNewTimelineForUnmigratedLiveEvent(clipData)) {
      EventBus.dispatch(CustomEvents.OpenEventMigrationPopup, { source: 'AudioControlsButton' });
      return;
    }
    setIsAudioPopupOpen(prev => {
      trackAudioControlButtonClick({ clipId: clipData?.id, isOpen: !prev, clipType: getClipDisplayLabel(clipData) });
      return !prev;
    });
  };

  return (
    <div className="relative">
      <div ref={triggerRef}>
        <TooltipV2
          tooltipId={'audio-controls-button'}
          tooltipContent={'Audio Settings'}
          noArrow
          place="top"
          positionStrategy="fixed"
          className="z-10"
          tooltipElement={
            <Button
              className={classnames('flex size-[42px] items-center justify-center !p-0')}
              variation="checkbox"
              trackingId={'audio-controls-button'}
              onMouseDown={clickHandler}
              buttonSize="base"
            >
              <Icon name={'IconAdjustmentsAlt'} size={15} className="timeline-icon" stroke={2.5} />
            </Button>
          }
        />
      </div>
      <AudioControlsPopup isOpen={isAudioPopupOpen} setIsOpen={setIsAudioPopupOpen} triggerRef={triggerRef} />
    </div>
  );
};
